import moment from "moment";

export class GetBranchReportReqData {
    public branchName: string = null;
    public currency: string = null;
    public startDate: Date = null;
    public endDate: Date = null;

    constructor() {
        this.reset();
    }

    reset(branchName?: string, currency?: string) {
        var startMoment = moment();
        startMoment.hours(0);
        startMoment.minutes(0);
        startMoment.seconds(0);
        this.startDate = startMoment.toDate();

        var endMoment = moment();
        endMoment.hours(23);
        endMoment.minutes(59);
        endMoment.seconds(59);
        this.endDate = endMoment.toDate();

        if (branchName) this.branchName = branchName;
        if (currency) this.currency = currency;
    }

    valid(): boolean {
        return this.branchName != "" && this.currency != "" && this.startDate != null && this.endDate != null && this.startDate < this.endDate;
    }
}
